import { Container } from "pixi.js";

export default class ObstacleContainer {
  public container: Container;
  constructor(container: Container) {
    this.container = container;
  }

  reset() {
    this.container = null as any;
  }
}
